import React, { useState, useEffect, useCallback } from 'react';

const API_URL = '';
const MN_LOGO = 'https://customer-assets.emergentagent.com/job_81a10ac5-4362-40b8-978c-4a083e804485/artifacts/wdep8365_9fae230d-cb5d-40ea-9872-218f366ffcef.jpeg';
const XCIPTV_LOGO = 'https://customer-assets.emergentagent.com/job_81a10ac5-4362-40b8-978c-4a083e804485/artifacts/eku1ncvt_IMG_5380.jpeg';

const HomePage = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [downloading, setDownloading] = useState(null);
  const [copied, setCopied] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/apps`)
      .then(res => res.json())
      .then(data => {
        const sorted = (data.apps || []).sort((a, b) => a.order - b.order);
        setApps(sorted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Navegacao por controle remoto
  const handleKeyDown = useCallback((e) => {
    const total = apps.length;
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      setFocusedIndex(p => Math.max(0, p - 1));
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      setFocusedIndex(p => Math.min(total - 1, p + 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const btn = document.querySelector(`[data-idx="${focusedIndex}"] .dl-btn`);
      if (btn) btn.click();
    }
  }, [apps.length, focusedIndex]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const doDownload = (app) => {
    if (!app.apk_filename) return;
    setDownloading(app.slug);
    const a = document.createElement('a');
    a.href = `${API_URL}/api/download/${encodeURIComponent(app.apk_filename)}`;
    a.download = '';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => setDownloading(null), 3000);
  };

  const doCopy = (code) => {
    const fallback = () => {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;left:-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    };
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(fallback);
    } else {
      fallback();
    }
    setCopied(code);
    setTimeout(() => setCopied(null), 2000);
  };

  const getIcon = (app) => {
    if (app.slug === 'mn-tech') return MN_LOGO;
    if (app.slug === 'xciptv') return XCIPTV_LOGO;
    return app.icon_url || MN_LOGO;
  };

  if (loading) {
    return (
      <div style={styles.page}>
        <p style={styles.loadingText}>Carregando...</p>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <header style={styles.header}>
        <img src={MN_LOGO} alt="MN" style={styles.headerLogo} />
        <div>
          <h1 style={styles.headerTitle}>MN Tech</h1>
          <p style={styles.headerSub}>Loja de Apps</p>
        </div>
      </header>

      {/* APPS */}
      <main style={styles.main}>
        {apps.map((app, idx) => {
          const focused = focusedIndex === idx;
          const isDownloading = downloading === app.slug;
          const isCopied = copied === app.downloader_code;
          const isFeatured = app.featured;

          return (
            <div
              key={app.slug}
              data-idx={idx}
              data-testid={`app-${app.slug}`}
              tabIndex={0}
              onFocus={() => setFocusedIndex(idx)}
              style={{
                ...styles.card,
                ...(isFeatured ? styles.cardFeatured : {}),
                ...(focused ? styles.cardFocused : {})
              }}
            >
              {/* ICON */}
              <img
                src={getIcon(app)}
                alt={app.name}
                style={{
                  ...styles.icon,
                  ...(isFeatured ? styles.iconFeatured : {})
                }}
              />

              {/* INFO */}
              <div style={styles.info}>
                <h2 style={{
                  ...styles.name,
                  ...(isFeatured ? styles.nameFeatured : {})
                }}>
                  {app.name}
                </h2>

                {/* BOTOES */}
                <div style={styles.buttons}>
                  {/* BAIXAR */}
                  <button
                    className="dl-btn"
                    data-testid={`download-${app.slug}`}
                    onClick={() => doDownload(app)}
                    style={{
                      ...styles.btnDownload,
                      ...(isFeatured ? styles.btnDownloadFeatured : {}),
                      ...(isDownloading ? styles.btnDownloading : {}),
                      ...(focused ? styles.btnFocused : {})
                    }}
                  >
                    {isDownloading ? 'BAIXANDO...' : 'BAIXAR APK'}
                  </button>

                  {/* CODIGO DOWNLOADER */}
                  {app.downloader_code && (
                    <button
                      data-testid={`code-${app.slug}`}
                      onClick={() => doCopy(app.downloader_code)}
                      style={{
                        ...styles.btnCode,
                        ...(isCopied ? styles.btnCopied : {}),
                        ...(focused ? styles.btnCodeFocused : {})
                      }}
                    >
                      {isCopied ? 'COPIADO!' : `COD: ${app.downloader_code}`}
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </main>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <p>Use SETAS para navegar | OK para baixar</p>
        <p style={styles.footerSmall}>MN Tecnologia 2025</p>
      </footer>
    </div>
  );
};

// CSS inline puro - maximo compatibilidade com TVs antigas
const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#000000',
    color: '#ffffff',
    fontFamily: 'Arial, Helvetica, sans-serif',
    padding: 0,
    margin: 0
  },
  loadingText: {
    textAlign: 'center',
    paddingTop: '40vh',
    fontSize: '24px',
    color: '#666666'
  },

  // HEADER
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px',
    borderBottom: '2px solid #222222',
    backgroundColor: '#000000'
  },
  headerLogo: {
    width: '60px',
    height: '60px',
    borderRadius: '12px',
    border: '2px solid #333333'
  },
  headerTitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    margin: 0,
    color: '#ffffff'
  },
  headerSub: {
    fontSize: '14px',
    margin: 0,
    color: '#666666'
  },

  // MAIN
  main: {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto'
  },

  // CARD
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '24px',
    marginBottom: '16px',
    backgroundColor: '#111111',
    border: '3px solid #222222',
    borderRadius: '16px',
    cursor: 'pointer'
  },
  cardFeatured: {
    backgroundColor: '#0a0a1a',
    border: '3px solid #333399',
    padding: '32px'
  },
  cardFocused: {
    border: '3px solid #00ff00',
    backgroundColor: '#001100'
  },

  // ICON
  icon: {
    width: '80px',
    height: '80px',
    borderRadius: '16px',
    border: '2px solid #333333',
    flexShrink: 0
  },
  iconFeatured: {
    width: '100px',
    height: '100px'
  },

  // INFO
  info: {
    flex: 1
  },
  name: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: '0 0 16px 0',
    color: '#ffffff'
  },
  nameFeatured: {
    fontSize: '32px'
  },

  // BUTTONS
  buttons: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap'
  },
  btnDownload: {
    display: 'inline-block',
    padding: '16px 32px',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#0066cc',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer'
  },
  btnDownloadFeatured: {
    padding: '20px 40px',
    fontSize: '22px',
    backgroundColor: '#0055aa'
  },
  btnDownloading: {
    backgroundColor: '#009900'
  },
  btnFocused: {
    backgroundColor: '#00aa00',
    outline: '3px solid #00ff00'
  },
  btnCode: {
    display: 'inline-block',
    padding: '16px 24px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#cc6600',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer'
  },
  btnCopied: {
    backgroundColor: '#009900'
  },
  btnCodeFocused: {
    outline: '2px solid #ffaa00'
  },

  // FOOTER
  footer: {
    textAlign: 'center',
    padding: '30px 20px',
    borderTop: '2px solid #222222',
    color: '#666666',
    fontSize: '16px'
  },
  footerSmall: {
    fontSize: '12px',
    marginTop: '8px',
    color: '#444444'
  }
};

export default HomePage;
